module.exports = __webpack_public_path__ + "img/funnel-community.9dd31024.png";